import { CloseIconButton } from '@library/components/buttons';
import { Message } from '@library/components/messages/Message';

export interface MessageBannerProps {
  className?: string;
  code: string;
  message: string;
  onCancel?: () => void;
}
export const MessageBanner = ({
  className = '',
  code,
  message,
  onCancel = undefined
}: MessageBannerProps) => {
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-2 z-10 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8"
      data-testid="message-banner"
    >
      <div className="bg-soFresh-120 pointer-events-auto flex items-center justify-between gap-x-6 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5">
        <Message
          className={className}
          code={code === 'ERROR' ? 'ERROR' : 'SUCCESS'}
          message={message}
        />
        {onCancel && <CloseIconButton handleOnClick={onCancel} />}
      </div>
    </div>
  );
};
